import { createSelector } from 'reselect';
import normalizationHelper, { formatInstructionSet } from '../../../VideoPlayer/utils/normalizationHelper';
import { getLanguage } from '@gameday/utils/selectors/getLanguage';
const formatInsStr = '{formatInstructions}';

const getHighlights = (state) => state?.highlightsplaylist?.videos;
const getLoading = (state) => state.loading?.isLoading;
const getDetail = (state) => state?.views?.detail;
const getGamePk = (state) => state.gumbo?.gamePk;
const getNormalizedHighlights = (highlights, gamePk, language) => {
    return (highlights?.map(highlight => {
        const { id, title, playbacks, templateUrl, description, duration } = highlight || {};
        const srcSet = {
            '1x': templateUrl?.replace(formatInsStr, formatInstructionSet['1x']),
            '2x': templateUrl?.replace(formatInsStr, formatInstructionSet['2x']),
            '3x': templateUrl?.replace(formatInsStr, formatInstructionSet['3x'])
        };
        const normalizedHighlight = normalizationHelper({ id, title, playbacks, srcSet, gamePk, language, description, duration });
        return { ...highlight, ...normalizedHighlight }; // TODO: normalizedHighlight should have all necessary/expected props... should normalize handle the srcSet?
    }));
};

export const getHighlightsPlaylist = createSelector(
    [getHighlights, getLoading, getDetail, getGamePk, getLanguage],
    (highlights, isLoading, detail, gamePk, language) => {
        return ({
            highlights: getNormalizedHighlights(highlights, gamePk, language),
            isLoading,
            defaultVideoSlug: detail,
            gamePk
        });
    }
);
